export default __webpack_public_path__ + "static/media/idol@2x.c95fe277.png";